import Vue from 'vue'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import LogAuthorization from '@/views/Authorization/components/logAuthorization/logAuthorization.vue'

import Role from '@/views/Authorization/models/role'
import Permissions from '@/views/Authorization/components/permissions/permissions.vue'
import Log from '@/views/Log/models/log'
import ProjectMixin from '@/_mixins/project'
import UserAvatar from '@/_components/avatar/user/user.vue'
import ProjectUserModel from '@/views/Authorization/models/projectUser'

@Component({
    inheritAttrs: false,
    name: 'RoleInfo',
    components: { DialogTemplate, Permissions, LogAuthorization, UserAvatar },
})
export default class RoleInfo extends Mixins<MixinInterface>(ProjectMixin) {
    @Prop({ required: true }) props!: any

    get role(): Role {
        return this.props.role
    }

    // INFINITELOADING can only be added when view is mounted
    logs: Array<Log> = []
    users: Array<any> = []
    timeStamp: string | null = new Date().toISOString()
    loading = false
    tabIndex = 0

    isMounted = false
    mounted() {
        this.isMounted = true
    }

    offset = 0
    limit = 50
    async getUsers($state: any) {
        let res = await Vue.prototype.$vbit
            .get('authorization', 'projectUsers', {
                include: ['user'],
                filters: {
                    'filter[userKindIfConfirmed]': 'normal',
                    'filter[roles][contains]': this.role._id,
                    'page[offset]': this.offset,
                    'page[limit]': this.limit,
                },
            })
            .catch(() => {
                $state.complete()
            })

        let users = res ? res.data.map((user) => new ProjectUserModel(user, res.included)) : []

        this.users = [...this.users, ...users]

        if (users.length === this.limit) {
            this.offset += this.limit

            $state.loaded()
        } else {
            if (this.users.length > 0) {
                $state.loaded()
            }
            $state.complete()
        }
    }

    async getLogs($state: any) {
        if (this.currentProjectId) {
            let res: Array<Log> = await this.role
                .getRoleLog(this.currentProjectId, this.timeStamp)
                .catch(() => {
                    $state.complete()
                })

            this.logs = [...this.logs, ...res]

            if (res.length == Log.limit) {
                let lastElement = res?.pop()
                this.timeStamp = lastElement ? lastElement?.['time'] : null
                $state.loaded()
            } else {
                this.timeStamp = null
                if (this.logs.length > 0) {
                    $state.loaded()
                }
                $state.complete()
            }
        }
    }
}
